import { Entitlement } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities/Entitlement';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { UserInfoProviderState } from './types';

const defaultUserInfoProviderState = (entitlements?: Nullable<Entitlement[]>): UserInfoProviderState => ({
  userInfo: null,
  customerList: null,
  entitlements: entitlements ?? [],
  selectedCustomerId: null,
  onSelectCustomerId: () => {},
  refetchDashboardData: () => {},
  loadingState: {
    isLoadingEntitlementsData: false,
  },
});

export { defaultUserInfoProviderState };
